export default function (selector) {
  return function () {
    return this.matches(selector);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/matcher.js
// module id = 395
// module chunks = 0